import { render, staticRenderFns } from "./fair_contact.vue?vue&type=template&id=0a90bfb6&scoped=true"
import script from "./fair_contact.vue?vue&type=script&lang=js"
export * from "./fair_contact.vue?vue&type=script&lang=js"
import style0 from "./fair_contact.vue?vue&type=style&index=0&id=0a90bfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90bfb6",
  null
  
)

export default component.exports